import { startEnglishIqSessionV2Api } from '@repo/sdk';
import { requireEnglishIqResponseData } from '../../actions/require-english-iq-response-data';

interface IStartEnglishIqV2WebSessionParams {
  locale: string;
  sourceShareId?: string;
  turnstileToken?: string;
  visitorId: string;
}

export async function startEnglishIqV2WebSession({
  locale,
  sourceShareId,
  turnstileToken,
  visitorId,
}: IStartEnglishIqV2WebSessionParams) {
  const response = await startEnglishIqSessionV2Api({
    kind: 'benchmark',
    locale,
    sourceShareId,
    turnstileToken,
    visitorId,
  });
  return requireEnglishIqResponseData(response.data.data);
}
